import * as api from '@/http'

export const ActionSetConditions = async ({ commit }) => {
  const conditions = await api.http.get('dash/conditions').then(
    (response) => response.body,
    (error) => error
  )
  commit('SET_conditions', conditions)
}
